module.exports = __webpack_public_path__ + "static/img/loginBg2.a9859a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/loginBg2.png
// module id = 8Qg3
// module chunks = 3